import withNavigate from "../../../routes/withNavigate";
import AboutPageCmsContainer from "./AboutPageCmsContainer.jsx";
import AboutPageCmsStore from "./AboutPageCmsStore";

export default AboutPageCmsStore(withNavigate(AboutPageCmsContainer));